export const isString = (value) => {
    return typeof value === "string";
};
export const isEmptyString = (value) => {
    return typeof value === "string" && value.length === 0;
};
export const isNotEmptyString = (value) => {
    return typeof value === "string" && value.length !== 0;
};
export const isStringArray = (value) => {
    return Array.isArray(value) && value.every(isString);
};
//# sourceMappingURL=string-type-guards.js.map